import { LayoutGrid, List } from 'lucide-react'
import { Button } from './Button'

export type ViewMode = 'table' | 'icons'

interface ViewModeToggleProps {
  mode: ViewMode
  onChange: (mode: ViewMode) => void
  tableLabel?: string
  iconsLabel?: string
  className?: string
}

export function ViewModeToggle({
  mode,
  onChange,
  tableLabel = 'Tabelle',
  iconsLabel = 'Icons',
  className = ''
}: ViewModeToggleProps) {
  return (
    <div
      className={`inline-flex items-center rounded-lg border border-gray-200 bg-white p-1 dark:border-gray-700 dark:bg-gray-900 ${className}`.trim()}
      role="group"
      aria-label="Ansicht wählen"
    >
      <Button
        type="button"
        size="sm"
        variant={mode === 'table' ? 'primary' : 'outline'}
        onClick={() => onChange('table')}
        aria-pressed={mode === 'table'}
        className="rounded-md"
      >
        <List className="h-4 w-4" aria-hidden />
        <span className="hidden sm:inline">{tableLabel}</span>
      </Button>
      <Button
        type="button"
        size="sm"
        variant={mode === 'icons' ? 'primary' : 'outline'}
        onClick={() => onChange('icons')}
        aria-pressed={mode === 'icons'}
        className="rounded-md"
      >
        <LayoutGrid className="h-4 w-4" aria-hidden />
        <span className="hidden sm:inline">{iconsLabel}</span>
      </Button>
    </div>
  )
}
